import React from 'react';

import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';
import FormFields from '../FormFields';
import { IsObjectEmpty, IsListEmpty, IsStringEmpty, htmlToText, Log, GetObjectClone } from '../../../utilities/CommonMethods';
import CloseIcon from "../../../assets/icons/icon-close-black.png";
import AddIcon from "../../../assets/icons/icon-add-blue.svg";

import classes from './AssignmentProblemForm.module.css';
import GradingGuideInput from '../../UI/GradingGuideInput/GradingGuideInput';
import RemoveIcon from '../../../assets/icons/icon-close-black.png';
import ResourceAPIController from '../../../webServices/ResourceAPIController';
import ConfirmationDialog from '../../Popups/ConfirmationDialog/ConfirmationDialog';


class AssignmentProblemForm extends React.Component {

    state = {
        newProblemFormData: GetObjectClone(FormFields.newAssignmentProblemFormData),
        newProblemFormValid: false,
        gradingGuidesList: [
            { id: '', value: '', maxScore: '', errorMessage: '', scoreErrorMessage: '', valid: true }
        ],
        showError: false,
        errorMessage: '',

        confirmationDialogMessage: 'Are you sure you want to delete this grading criteria?',
        confirmationPrimaryButtonLabel: 'DELETE',
        confirmationSecondaryButtonLabel: 'CANCEL',
        selectedIndex: ''
    }


    confirmationSecondaryButtonClick = () => {
        this.setState({ showConfirmationDialog: false });
    }

    confirmationPrimaryButtonClicked = () => {
        let updatedGradingList = [...this.state.gradingGuidesList];

        if (!IsStringEmpty(this.state.selectedIndex) && this.state.selectedIndex > -1) {
            if (!IsStringEmpty(updatedGradingList[this.state.selectedIndex].id)) {
                this.deleteGradingCriteria(updatedGradingList[this.state.selectedIndex].id);
                updatedGradingList.splice(this.state.selectedIndex, 1);
            } else {
                updatedGradingList.splice(this.state.selectedIndex, 1);
            }
            this.setState({ gradingGuidesList: updatedGradingList, showConfirmationDialog: false });
        }
    }

    checkRemainingCount = (value, inputIdentifier) => {
        var maxLength = this.state.newProblemFormData[inputIdentifier].totalChar;
        var remainingCount = maxLength - value.length;
        return (remainingCount);
    }

    checkValidity = (formElement) => {
        let isValid = true;

        if (!IsObjectEmpty(formElement.validation)) {
            let value = formElement.value;
            const rules = formElement.validation;
            if (!IsObjectEmpty(rules.required) && rules.required.value) {
                if (typeof (value) === 'string' && value !== ' ' && value !== '' && value.length > 0) {
                    isValid = true && isValid;
                } else if ((typeof (value) === 'number' && parseInt(value, 10)) || value === 0) {
                    isValid = true && isValid;
                } else {
                    isValid = false;
                }
                formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
                formElement.valid = isValid;
            }

            if (!IsObjectEmpty(rules.isDropdown) && rules.isDropdown.value) {
                isValid = (value >= 0) && isValid;
                formElement.errorMessage = isValid ? '' : rules.isDropdown.errorMessage;
                formElement.valid = isValid;
            }
        }
        return (formElement);
    }

    inputChangedHandlerText = (event, inputIdentifier) => {
        const updatedForm = this.state.newProblemFormData;
        let updatedFormElement = updatedForm[inputIdentifier];
        if (inputIdentifier === 'assignmentTitle') {
            updatedFormElement.remainingChar = this.checkRemainingCount(event.target.value, inputIdentifier);

            if (updatedFormElement.remainingChar <= 0) {
                updatedFormElement.value = event.target.value.substring(0, updatedFormElement.totalChar);
                updatedFormElement.remainingChar = 0;
            } else {
                updatedFormElement.value = event.target.value;
            }
        } else {
            updatedFormElement.value = event.target.value;
        }
        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }
        this.setState({ newProblemFormData: updatedForm, newProblemFormValid: formIsValid });
    }

    inputChangedHandlerMarkdown = (value, inputIdentifier) => {
        // Log('Markdown handler called');
        value = value === '<p><br></p>' ? '' : value;
        const plainTextValue = htmlToText(value);

        const updatedForm = this.state.newProblemFormData;
        let updatedFormElement = updatedForm[inputIdentifier];
        if (inputIdentifier === 'problemDescription') {
            updatedFormElement.remainingChar = this.checkRemainingCount(plainTextValue, inputIdentifier)
            if (updatedFormElement.remainingChar <= 0) {
                updatedFormElement.value = value.substring(0, updatedFormElement.totalChar);
                updatedFormElement.remainingChar = 0;
            } else {
                updatedFormElement.value = value;
            }
        }

        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        this.setState({ newProblemFormData: updatedForm, newProblemFormValid: formIsValid });
    }

    onDropDownClick = (inputIdentifier) => {
        const updatedForm = this.state.newProblemFormData;
        const updatedFormElement = updatedForm[inputIdentifier];
        const updatedState = updatedFormElement.dropdownOpen ? false : true;

        for (let item in updatedForm) {
            updatedForm[item].dropdownOpen = false;
        }

        updatedFormElement.dropdownOpen = updatedState;
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        this.setState({ newProblemFormData: updatedForm, newProblemFormValid: formIsValid });
    }

    onDropDownItemClick = (pos, inputIdentifier) => {
        const updatedForm = this.state.newProblemFormData;
        let updatedFormElement = updatedForm[inputIdentifier];

        updatedFormElement.value = pos;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedFormElement.dropdownOpen = false;
        updatedForm[inputIdentifier] = updatedFormElement;

        this.setState({ newProblemFormData: updatedForm });
    }

    onGradingGuideInputChanged = (event, index, inputField) => {
        let updatedGradingGuidesList = [...this.state.gradingGuidesList];
        let updatedValue = event.target.value;
        let inputValid = !IsStringEmpty(updatedValue);
        let errorMessage = '', scoreErrorMessage = '';

        if (inputField === 'objective') {
            if (updatedValue.length === 0) {
                errorMessage = "This is a required field"
                inputValid = inputValid && false;
            } else {
                errorMessage = '';
                inputValid = inputValid && true;
            }

            updatedGradingGuidesList[index].value = event.target.value;
            updatedGradingGuidesList[index].errorMessage = errorMessage;

        } else if (inputField === 'score') {
            if (updatedValue.length === 0) {
                scoreErrorMessage = "This is a required field"
                inputValid = inputValid && false;
            } else if (isNaN(parseInt(updatedValue, 10)) === true || parseInt(updatedValue, 10) < 0) {
                scoreErrorMessage = "Please enter a valid score"
                inputValid = inputValid && false;
            } else {
                scoreErrorMessage = '';
                inputValid = inputValid && true;
            }

            updatedGradingGuidesList[index].maxScore = event.target.value;
            updatedGradingGuidesList[index].scoreErrorMessage = scoreErrorMessage;
        }

        updatedGradingGuidesList[index].valid = inputValid;

        this.setState({ gradingGuidesList: updatedGradingGuidesList });
    }

    onAddNewObjectiveClicked = () => {
        let updatedGradingGuidesList = [...this.state.gradingGuidesList];

        updatedGradingGuidesList.push({ value: '', maxScore: '', errorMessage: '', scoreErrorMessage: '', valid: true });

        this.setState({ gradingGuidesList: updatedGradingGuidesList });
    }

    removeOptionClicked = (pos) => {
        this.setState({ showConfirmationDialog: true, selectedIndex: pos });
    }

    onFormButtonClicked = () => {
        const updatedForm = this.state.newProblemFormData;
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        let updatedGradingGuidesList = [...this.state.gradingGuidesList], gradingGuideIsValid = true;
        for (var i = 0; i < updatedGradingGuidesList.length; i++) {

            let gradingGuide = updatedGradingGuidesList[i];

            gradingGuideIsValid = gradingGuideIsValid && gradingGuide.valid && gradingGuide.value !== '' && gradingGuide.maxScore !== '';
            if (gradingGuideIsValid === false) {
                if (gradingGuide.value === '') {
                    updatedGradingGuidesList[i].errorMessage = "This is a required field";
                    updatedGradingGuidesList[i].valid = false;
                }
                if (gradingGuide.maxScore === '') {
                    updatedGradingGuidesList[i].scoreErrorMessage = "This is a required field";
                    updatedGradingGuidesList[i].valid = false;
                }
            }
        }

        // console.log('STatus before submit -> ', formIsValid, gradingGuideIsValid)
        this.setState({ newProblemFormData: updatedForm, newProblemFormValid: formIsValid && gradingGuideIsValid, gradingGuidesList: updatedGradingGuidesList });

        if (formIsValid && gradingGuideIsValid) {
            let updatedGradingGuidesList = [...this.state.gradingGuidesList], gradingGuideList = [];
            for (var i = 0; i < updatedGradingGuidesList.length; i++) {
                if (this.props.forEdit) {
                    gradingGuideList.push(
                        {
                            "name": updatedGradingGuidesList[i].value,
                            "total_points": updatedGradingGuidesList[i].maxScore,
                            "id": updatedGradingGuidesList[i].id,
                        }
                    );
                } else {
                    gradingGuideList.push(
                        {
                            "name": updatedGradingGuidesList[i].value,
                            "total_points": updatedGradingGuidesList[i].maxScore
                        }
                    );
                }
            }

            let difficultyLevelOptions = this.state.newProblemFormData.difficultyLevel.options,
                difficultyLevel = this.state.newProblemFormData.difficultyLevel.value,
                difficultyLevelValue = difficultyLevelOptions[difficultyLevel].value;


            const newProblemData = {};
            newProblemData["name"] = this.state.newProblemFormData.assignmentTitle.value;
            newProblemData["difficulty_level"] = difficultyLevelValue;
            newProblemData["description"] = this.state.newProblemFormData.problemDescription.value;
            newProblemData["grading_criterias"] = gradingGuideList;

            // console.log("Final Object => ", newProblemData);
            if (this.props.forEdit) {
                this.props.editAssignmentProblemClicked(this.props.data.id, newProblemData, this.props.pos);
            } else {
                this.props.addNewAssignmentProblemClicked(newProblemData, this.props.pos);
            }
        }
    }

    setFormData = () => {
        const problemData = !IsObjectEmpty(this.props.data) ? this.props.data : {};
        if (problemData !== {} && this.props.forEdit === true) {
            // alert('Setting UP Initial Data');

            let assignmentName = '', difficultyLevel = -1, maxScore = '', problemDescription = '', gradingGuidesList = [];

            assignmentName = !IsStringEmpty(problemData.name) ? problemData.name : '';

            difficultyLevel = !IsStringEmpty(problemData.level)
                ? problemData.level === 'easy' ? 0
                    : problemData.level === 'medium' ? 1
                        : problemData.level === 'hard' ? 2
                            : 0 : 0;

            // maxScore = !IsStringEmpty(problemData.score) ? problemData.score : 0;

            problemDescription = !IsStringEmpty(problemData.description) ? problemData.description : '';

            gradingGuidesList = !IsListEmpty(problemData.gradingGuidesList) ? problemData.gradingGuidesList.map((item) => {
                return ({ id: item.id, value: item.value, maxScore: item.maxScore, errorMessage: '', scoreErrorMessage: '', valid: true });
            }) : [{ id: '', value: '', maxScore: '', errorMessage: '', scoreErrorMessage: '', valid: true }];

            let updatedFormData = { ...this.state.newProblemFormData };
            updatedFormData['assignmentTitle'].value = assignmentName;
            updatedFormData['difficultyLevel'].value = difficultyLevel;
            // updatedFormData['maxScore'].value = maxScore;
            updatedFormData['problemDescription'].value = problemDescription;

            this.setState({ newProblemFormData: updatedFormData, gradingGuidesList: gradingGuidesList });


        } else {
            // alert('Adding a new Problem');
        }
    }

    deleteGradingCriteria = (gradingCriteriaId) => {
        ResourceAPIController.deleteGradingCriteria(gradingCriteriaId)
            .then(response => {
                let responseObj = response.result;
                // console.log('Successfully deleted grading criteria');

                this.setState({
                    showContentLoader: false
                });
            })
            .catch(err => {
                console.log('[Delete grading criteria] error => ', err)
                this.setState({ showContentLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    componentDidMount() {
        this.setFormData();
    }

    inputField = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.newProblemFormData[key].elementType}
            elementConfig={this.state.newProblemFormData[key].elementConfig}
            label={this.state.newProblemFormData[key].label}
            value={this.state.newProblemFormData[key].value}
            options={this.state.newProblemFormData[key].options}
            changed={key === 'problemDescription' ? (value) => this.inputChangedHandlerMarkdown(value, key) : (event) => this.inputChangedHandlerText(event, key)}
            touched={this.state.newProblemFormData[key].touched}
            afterText={this.state.newProblemFormData[key].remainingChar}
            dropdownOpen={this.state.newProblemFormData[key].dropdownOpen}
            onDropDownClick={() => this.onDropDownClick(key)}
            onDropDownItemClick={this.onDropDownItemClick}
            videoType={this.props.videoType}
            required={!IsObjectEmpty(this.state.newProblemFormData[key].validation) ? (!IsObjectEmpty(this.state.newProblemFormData[key].validation.required) ? this.state.newProblemFormData[key].validation.required.value : false) : false}
            showError={(!this.state.newProblemFormValid && !this.state.newProblemFormData[key].valid) ? true : false}
            error={this.state.newProblemFormData[key].errorMessage} />
    }

    render() {

        const renderGradingGuidesList = !IsListEmpty(this.state.gradingGuidesList)
            ? this.state.gradingGuidesList.map((item, index) => {
                return (
                    <div key={index}>
                        <GradingGuideInput
                            pos={index}
                            value={item.value}
                            maxScore={item.maxScore}
                            onInputChanged={this.onGradingGuideInputChanged}
                            errorMessage={item.errorMessage}
                            scoreErrorMessage={item.scoreErrorMessage}
                            removeOptionClick={this.removeOptionClicked}
                        />
                    </div>
                );
            }) : null;

        return (
            <>
                {
                    this.state.showConfirmationDialog
                        ? <ConfirmationDialog
                            showLoading={this.state.showDialogLoader}
                            show={this.state.showConfirmationDialog}
                            message={this.state.confirmationDialogMessage}
                            secondaryButtonLabel={this.state.confirmationSecondaryButtonLabel}
                            secondaryButtonClick={this.confirmationSecondaryButtonClick}
                            primaryButtonLabel={this.state.confirmationPrimaryButtonLabel}
                            primaryButtonClicked={this.confirmationPrimaryButtonClicked} />
                        : null
                }
                <div className={classes.Form}>

                    <h4 className={classes.Heading}>{this.props.forEdit ? 'Edit Problem ' + (this.props.pos + 1) : 'Add New Problem'}</h4>

                    <img src={CloseIcon} alt={'Hide add new problem form'} className={classes.CloseIcon}
                        onClick={this.props.forEdit ? () => this.props.hideEditForm(this.props.pos) : this.props.hideForm} />

                    <p className={classes.SubHeading}>Problem Details</p>

                    <div className={classes.TitleInput}>
                        {this.inputField('assignmentTitle')}
                    </div>

                    <div className={classes.HorizontalInputs}>
                        <div className={classes.LevelInput}>
                            {this.inputField('difficultyLevel')}
                        </div>
                        {/* <div className={classes.ScoreInput}>
                        {this.inputField('maxScore')}
                    </div> */}
                    </div>

                    <p className={classes.SubHeading}>Problem Description</p>

                    <div className={classes.DescriptionInput}>
                        {this.inputField('problemDescription')}
                    </div>

                    <p className={classes.SubHeading}>Grading Guide</p>

                    <div className={classes.GradingGuideContainer}>
                        {renderGradingGuidesList}
                        {
                            this.state.showError
                                ? <p className={classes.ErrorMessage}>{this.state.errorMessage}</p>
                                : null
                        }
                        <div className={classes.AddNewOptionDiv} onClick={this.onAddNewObjectiveClicked}>
                            <img src={AddIcon} alt="Add New Objective" />
                            <p>Add new objective</p>
                        </div>
                    </div>

                    <div className={classes.SubmitButton}>
                        <Button
                            styleclass="NonMobileOnly"
                            label={this.props.forEdit ? "UPDATE PROBLEM" : "ADD PROBLEM"}
                            fontSize="0.8em"
                            padding="1em 3.5em"
                            clicked={this.onFormButtonClicked}
                        />
                        <Button
                            width="6em"
                            styleclass="MobileOnly"
                            label={this.props.forEdit ? "UPDATE PROBLEM" : "ADD PROBLEM"}
                            fontSize="0.625em"
                            padding="1em 3em"
                            margin="0px"
                            clicked={this.onFormButtonClicked}
                        />
                    </div>
                </div>
            </>
        );
    }
}

export default AssignmentProblemForm;